import { Injectable } from '@angular/core';
import { IPaymentSource } from '@core/interfaces/payment/payment-source.interface';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { IPayment } from '@core/interfaces/payment/payment.interface';
import { HttpService } from '@interticket/core';

@Injectable()
export class PaymentSourceService implements IPaymentSource {

  private readonly paymentServiceVersion: string = environment.modules.core.payment.version;
  private readonly paymentServiceBaseUrl: string = `/${this.paymentServiceVersion}/payment/web`;

  constructor(
    private httpService: HttpService
  ) { }

  getPaymentMethods(): Observable<IListResult<IPayment>> {
    return this.httpService.get<IListResult<IPayment>>(`${this.paymentServiceBaseUrl}/method`);
  }

}
